import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-modal-residence-certificate',
  templateUrl: './modal-residence-certificate.component.html',
  styleUrls: ['./modal-residence-certificate.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule]
})
export class ModalResidenceCertificateComponent {
  dontShowAgain: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ModalResidenceCertificateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router
  ) {}

  onAddCertificate(): void {
    // Guardar la preferencia antes de redirigir
    if (this.dontShowAgain && this.data.onDontShowAgain) {
      this.data.onDontShowAgain(true);
    }
    
    this.dialogRef.close({ action: 'add', dontShowAgain: this.dontShowAgain });
    
    // Redirigir a /perfil/residencia-fiscal con el tab aportar-certificado
    this.router.navigate(['/perfil/residencia-fiscal'], { 
      queryParams: { tab: 'aportar-certificado' } 
    });
  }

  onNoThanks(): void {
    // Siempre guardar la preferencia al cerrar con "Ahora no" (crear variable si no existe)
    // true si marcó "no volver a mostrar", false en caso contrario
    if (this.data.onDontShowAgain) {
      this.data.onDontShowAgain(this.dontShowAgain);
    }

    this.dialogRef.close({ action: 'cancel', dontShowAgain: this.dontShowAgain });
  }

  onCloseX(): void {
    // Cerrar con X: guardar false para que siga mostrándose en el futuro
    if (this.data.onDontShowAgain) {
      this.data.onDontShowAgain(false);
    }
    this.dialogRef.close({ action: 'close-x', dontShowAgain: false });
  }
}

